import { getServerBaseURL } from 'src/utils/base';
import { getTable } from 'src/utils/common';
import { request } from '../boot/request';

const baseURL = getServerBaseURL('ordercart');

export const reqAddToCart = params => request({
  baseURL,
  url: '/cart/addToCart',
  method: 'POST',
  data: params
})

export const getCart = params => {
  params = params || {};
  let cancelToken = null
  if (params.cancelToken) {
    cancelToken = params.cancelToken
    delete params.cancelToken
  }
  return request({
    baseURL,
    url: '/cart',
    method: 'POST',
    cancelToken,
    timeout: 30000,
    data: params,
  });
};

export const updateCart = params => request({
  baseURL,
  url: '/cart/updateCart',
  method: 'POST',
  data: params
})

export const getHash = params => request({
  baseURL,
  url: '/cart/getProductHash',
  method: 'GET',
  params
})

export function clearInvalidCartItem(params) {
  const tableNumber = getTable();
  return request({
    baseURL,
    url: '/cart/clearInvalidCartItem',
    method: 'POST',
    data: { tableNumber }
  });
}

export const reqOrder = params => request({
  baseURL,
  url: '/order/placeOrder',
  method: 'POST',
  data: params
})

export const getHasComment = params => request({
  baseURL,
  url: '/order/hasComment',
  method: 'GET',
  params
})

export const getOrder = params => {
  params = params || {};
  return request({
    baseURL,
    url: '/order/detail',
    method: 'POST',
    data: params,
  });
};


// 新的支付接口full dine in
export const checkoutReview = params => request({
  url: '/checkoutReview',
  method: 'GET',
  params
})

export const checkout = params => request({
  url: '/quickCheckout',
  method: 'POST',
  data: params
})

export const reqUseCouPon = params => request({
  url: '/quickUseCoupon',
  method: 'POST',
  data: params
})

export const reqRemoveCoupon = params => request({
  url: '/quickRemoveCoupon',
  method: 'POST',
  data: params
})

export const reqCallWaiter = params => request({
  baseURL,
  url: '/order/callWaiter',
  params,
})
